<template>
  <div class="statistics-backStudy">
    <div class="ly-card hd">
     <el-select
        class="m-r-10"
        v-model="searchFormData.org_id"
        placeholder="部门"
        @change="getRootSp"
        @clear="search"
        filterable
        clearable
      >
        <el-option v-for="item in org_ids" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select
        class="m-r-10"
        v-model="searchFormData.root_specialized_subject_id"
        placeholder="项目大类"
        :disabled="!searchFormData.org_id"
        @clear="search"
        @change="getSp"
        filterable
        clearable
      >
        <el-option v-for="item in root_specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        class="m-r-10"
        @clear="search"
        @change="search"
        v-model="searchFormData.specialized_subject_id"
        placeholder="项目"
        filterable
        clearable
        :disabled="!searchFormData.org_id || !searchFormData.root_specialized_subject_id"
      >
        <el-option v-for="item in specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <!-- <el-form-item class="fee-level-search" label="任课老师" prop="teacher_ids">
        <remote-search
          ref="teacher_ids"
          :options="teacher_ids"
          @input="(value, label, data) => teacherhandleChange(value, label, data)"
        />
      </el-form-item> -->
      <span>上学期</span>
      <el-select v-model="searchFormData.compare_year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select v-model="searchFormData.compare_term" placeholder="学期">
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <span>本学期</span>
      <el-select v-model="searchFormData.cal_year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select v-model="searchFormData.cal_term" placeholder="学期">
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-button @click="search">查询</el-button>
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </div>
    <!-- <div height="400" width="550" v-show="canvasData.length" > -->
    <div v-loading="loading">
      <div class='chartBox'>
        <div id="chartBox" ref="charts" class="ly-card" :style="chartStyle"></div>
      </div>
      <ly-table
        :tableHeader="tableHeader"
        :paginConfig="paginConfig"
        :searchFormData="searchFormData"
        :tableConfig="tableConfig"
        class="ly-card"
        ref="lyTable"
      >
        <template v-slot:header_back_student_count>
          老生返读人数
          <el-tooltip class="item" effect="light" content="上学期报名的学员本学期也报名" placement="top">
            <i class="el-icon-warning-outline" style="color:#e6a23c" />
          </el-tooltip>
        </template>
        <template v-slot:header_back_student_rate>
          老生返读率
          <el-tooltip class="item" effect="light" content="老生注册人数/上学期报名学员数量" placement="top">
            <i class="el-icon-warning-outline" style="color:#e6a23c"  />
          </el-tooltip>
        </template>
        <template v-slot:org_full_names="row">
        {{ row.org_full_names && row.org_full_names.replace(/中国儿童中心\/+/, '') }}
        </template>
        <template v-slot:header_compare_contact_count>
          <div>上学期（{{ searchFormData.compare_year }}年/ {{ label(searchFormData.compare_term) }}）</div>
        </template>
        <template v-slot:header_cal_contact_count>
          <div>本学期({{ searchFormData.cal_year }}年/ {{ label(searchFormData.cal_term) }})  </div>
        </template>
        <template v-slot:back_student_rate="row">
          <el-progress :percentage="(((row.back_student_rate || 0)*100).toFixed(2))*1" :color="customColorMethod"></el-progress>
        </template>
      </ly-table>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Select, Option, Progress, Tooltip } from 'element-ui';
import LyTable from '@/components/LyTable';
import { backStudyTable } from '@/utils/tableHeader';
import { report, finance } from '@/api';
import utils from '@/utils/utils';
import * as echarts from 'echarts';
// import RemoteSearch from '@/components/common/RemoteSearch';
import { teacher_ids } from '@/utils/formConfigCommon';

Vue.prototype.$echarts = echarts;
export default {
  name: 'statisticsBackStudy',
  components: { ElSelect: Select, ElOption: Option, LyTable, ElProgress: Progress, ElTooltip: Tooltip },
  data() {
    return {
      teacher_ids: {
        ...teacher_ids.options,
        key: 'teacher_ids'
      },
      searchFormData: {
        cal_year: new Date().getFullYear(),
        cal_term: '',
        compare_year: new Date().getFullYear(),
        compare_term: '',
        org_id: '',
        specialized_subject_id: '',
        root_specialized_subject_id: ''
      },
      org_ids: [],
      root_specialized_subject_ids: [],
      specialized_subject_ids: [],
      terms: [],
      years: [],
      tableHeader: backStudyTable,
      tableConfig: {
        border: true
      },
      loading: false,
      paginConfig: {
        isHide: true
      },
      chartStyle: {
        height: `${3500}px`
      },
      chartOption: {
        title: {
          text: '返读人数统计图',
          textStyle: {
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '1%',
          right: '4%',
          bottom: '3%',
          y: 30,
          y2: 60,
          containLabel: true
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          // max: 5,
          data: [],
          axisLabel: {
            interval: 0
          }
        },
        series: [
          {
            name: '返读人数',
            barGap: 5,
            type: 'bar',
            data: [],
            barWidth: 15,
            barCateGoryGap: 5,
            label: {
              show: true,
              position: 'right',
              color: '#000'
            }
          }
        ]
      },
      chartData: [],
      chart: {}
    };
  },
  created() {
    this.init();
    this.getOrg();
    window.addEventListener('resize', () => {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.chart.resize();
      }, 100);
    });
  },
  computed: {
    label() {
      return value => {
        if (value) return this.terms.find(item => item.value === value).label;
        return '';
      };
    }
  },
  methods: {
    init() {
      this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
        if (data) {
          this.years = data.year;
          this.terms = data.term;
          this.searchFormData.cal_term = data.term[0].value;
          this.searchFormData.compare_term = data.term[0].value;
          this.search();
        }
      });
    },
    teacherhandleChange(value) {
      console.log(value);
    },
    customColorMethod(percentage) {
      if (percentage < 5) {
        return '#e6a23c';
      } if (percentage < 90) {
        return '#409eff';
      }
      return '#67c23a';
    },
    getOrg() {
      finance.orgQuery().then(res => {
        if (res) {
          this.org_ids = res.data.list;
        }
      });
    },
    changeOrg(row) {
      this.searchFormData.org_id = row.org_id;
      this.getRootSp();
    },
    getRootSp() {
      this.searchFormData.specialized_subject_id = '';
      this.searchFormData.root_specialized_subject_id = '';
      if (this.searchFormData.org_id) {
        finance.rootSpecializedSubjectQuery({ org_id: this.searchFormData.org_id }).then(res => {
          if (res) {
            this.root_specialized_subject_ids = res.data.list;
          }
        });
      } else {
        this.root_specialized_subject_ids = [];
      }
      this.search();
    },
    getSp() {
      this.searchFormData.specialized_subject_id = '';
      if (this.searchFormData.org_id && this.searchFormData.root_specialized_subject_id) {
        finance
          .specializedSubjectQuery({
            org_id: this.searchFormData.org_id,
            root_specialized_subject_id: this.searchFormData.root_specialized_subject_id
          })
          .then(res => {
            if (res) {
              this.specialized_subject_ids = res.data.list;
            }
          });
      } else {
        this.specialized_subject_ids = [];
      }
      this.search();
    },
    change(value, key) {
      this.searchFormData[key] = value;
    },
    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) delete params[key];
      });
      report
        .exportBackStudyRate({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '项目返读率统计');
        });
    },
    async search() {
      this.loading = true;
      const res = await report.getBackStudyStatistics(this.searchFormData);
      if (res) {
        this.tableConfig = {
          ...this.tableConfig,
          data: res.data.list
        };
        this.chartData = window.cloneDeep(res.data.list);
      }
      this.setChart();
    },
    setChart() {
      const count = [];
      const name = [];
      this.chartData.sort(this.compare('back_student_count')).map(item => {
        count.push(item.back_student_count);
        name.push(item.specialized_subject_name);
        return item;
      });
      this.chartOption.yAxis.data = name;
      this.chartOption.series[0].data = count;
      const Chart = this.$echarts.init(document.getElementById('chartBox'));
      Chart.setOption(this.chartOption);
      this.chart = Chart;
      if (name.length > 100) {
        this.chartStyle.height = `${(name.length * 30) + 75}px`;
      } else {
        this.chartStyle.height = `${(name.length * 40) + 75}px`;
      }
      setTimeout(() => {
        this.chart.resize();
        this.loading = false;
      }, 100);
    },
    compare(property) {
      return (a, b) => {
        const value1 = a[property];
        const value2 = b[property];
        return value1 - value2;
      };
    }
  }
};
</script>
<style lang="less">
.statistics-backStudy {
  .hd {
    .el-select {
      width: 100px;
    }
    .m-r-10{
      width:140px;
    }
    .ly-search-comp {
      display: inline-block;
      width: 300px;
      .el-select {
        width: 100%;
      }
      .el-input {
        width: 100%;
      }
    }
    > * {
      margin: 0 10px;
    }
  }
  .el-progress--line{
    .el-progress__text{
      font-size:12px !important;
    }
  }
  .chartBox{
    max-height:350px;
    overflow-y:auto;
    background:#fff;
  }
}
</style>
